const Default = () => {
  window.location.replace('https://www.akouo.io/');
  return <></>;
};

export default Default;
